/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";
import { ComponentSearchBar } from "cms/models/layout/model-components-box/component-actions-bar/component-search-bar";
import cn from "classnames";

const ComponentActionsBar = (props) => {

    const handleSortChange = props?.handleSortChange;
    const isDisabled = props?.isDisabled;
    const isFilterBarShown = props?.isFilterBarShown;
    const isSortedAtoZ = props?.isSortedAtoZ;
    const searchTerm = props?.searchTerm;
    const setSearchTerm = props?.setSearchTerm;
    const showFilterBar = props?.showFilterBar;

    const containerClass = cn("components-action-bar", { disabled: isDisabled });
    const filterButtonClass = cn("component-action-button", { active: isFilterBarShown });

    return (
        <div className={containerClass}>
            <ComponentSearchBar
                isDisabled={isDisabled}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
            />
            <Button
                className='component-action-button'
                disabled={isDisabled}
                onClick={handleSortChange}
            >
                {isSortedAtoZ && <SVGIcons.common.Sort />}
                {!isSortedAtoZ && <SVGIcons.common.SortReverse />}
            </Button>
            <Button
                className={filterButtonClass}
                disabled={isDisabled}
                onClick={showFilterBar}
            >
                <SVGIcons.common.Filter />
            </Button>
        </div>
    );
};

export { ComponentActionsBar };
